import { Tooltip } from 'antd';
import { useEffect, useRef, useState } from 'react';
import LanguageTranslator from '../locals/LanguageTranslator';

const TextWithTooltip = ({
    text = '',
    width,
    maxChars,
    placement = 'top',
    className = '',
    as: Component = 'span',
    ...rest
}) => {
    const ref = useRef(null);
    const [overflowByWidth, setOverflowByWidth] = useState(false);

    let displayText = text;
    let shouldShowTooltip = false;
    const style = {};

    /* ---------- Width styling ---------- */
    if (width) {
        style.maxWidth = typeof width === 'number' ? `${width}px` : width;
    }

    /* ---------- maxChars logic ---------- */
    if (maxChars && text.length > maxChars) {
        displayText = `${text.slice(0, maxChars)}…`;
        shouldShowTooltip = true;
    }

    /* ---------- Width overflow detection ---------- */
    useEffect(() => {
        if (!width || maxChars) return;

        const el = ref.current;
        if (!el) return;

        let rafId;

        const checkOverflow = () => {
            rafId = requestAnimationFrame(() => {
                if (!el) return;
                const { scrollWidth, clientWidth } = el;
                if (clientWidth === 0 || scrollWidth === 0) return;
                setOverflowByWidth(scrollWidth > clientWidth);
            });
        };

        checkOverflow();

        const observer = new ResizeObserver(checkOverflow);
        observer.observe(el);

        return () => {
            cancelAnimationFrame(rafId);
            observer.disconnect();
        };
    }, [text, width, maxChars]);

    if (width && !maxChars && overflowByWidth) {
        shouldShowTooltip = true;
    }

    const content = (
        <Component
            ref={ref}
            className={`inline-block truncate ${className}`}
            style={style}
            {...rest}
        >
            <LanguageTranslator>{displayText}</LanguageTranslator>
        </Component>
    );

    return shouldShowTooltip ? (
        <Tooltip
            overlayStyle={{ fontSize: '12px' }}
            overlayClassName='!p-0'
            title={<div className='max-h-[50vh] overflow-auto'>{text}</div>}
            placement={placement}
        >
            {content}
        </Tooltip>
    ) : (
        content
    );
};

export default TextWithTooltip;
